export default __webpack_public_path__ + "static/2-78c18e7ccb75013c66a766f25c621fa8.jpg";